"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "HighlightedText", {
    enumerable: true,
    get: function() {
        return HighlightedText;
    }
});
var _react = _interop_require_default(require("react"));
var _components = require("@cmpsr/components");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var HighlightedText = function(_param) {
    var _param_backgroundColor = _param.backgroundColor, backgroundColor = _param_backgroundColor === void 0 ? "background-page" : _param_backgroundColor, _param_contentAlignment = _param.contentAlignment, contentAlignment = _param_contentAlignment === void 0 ? "start" : _param_contentAlignment, rest = _object_without_properties(_param, [
        "backgroundColor",
        "contentAlignment"
    ]);
    return _react.default.createElement(_components.Flex, _object_spread({
        backgroundColor: backgroundColor,
        flexDirection: "column",
        gap: {
            base: "0.75rem",
            lg: "1rem"
        },
        px: {
            base: "1.25rem",
            md: "1.5rem",
            lg: "3rem",
            xl: "6rem",
            xxl: "7rem"
        },
        py: {
            base: "2.5rem",
            md: "4rem",
            lg: "5rem",
            xl: "5.5rem",
            xxl: "6rem"
        },
        alignItems: contentAlignment,
        textAlign: contentAlignment
    }, rest));
};
HighlightedText.Title = _components.TextPairing;
var HighlightedTextLinkGroup = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        gap: {
            base: "1rem",
            md: "1.5rem"
        },
        flexDirection: {
            base: "column",
            md: "row"
        },
        mt: {
            base: "0.75rem",
            lg: "1rem",
            xl: "2rem"
        },
        width: {
            base: "100%",
            md: "unset"
        }
    }, props));
};
HighlightedText.Actions = HighlightedTextLinkGroup;
var HighlightedTextLink = function(props) {
    return _react.default.createElement(_components.Link, _object_spread({
        target: "_blank",
        size: "l",
        justifyContent: "center"
    }, props));
};
HighlightedText.Action = HighlightedTextLink;
var HighlightedTextLegend = function(props) {
    return _react.default.createElement(_components.Text, _object_spread({
        color: "text-secondary",
        variant: "text-body-display-S",
        textTransform: "uppercase",
        display: "flex"
    }, props));
};
HighlightedText.Overline = HighlightedTextLegend;
